
<div class="container">
	<app-price-protection-details *ngIf="entry" [entry]="entry"></app-price-protection-details>
</div>

